import React from 'react';
import cx from 'classnames';
import Icon from 'components/Icon';
import styles from './TaskListHeader.m.sass';
var TaskListHeader = function TaskListHeader(_ref) {
  var title = _ref.title,
    completedCount = _ref.completedCount,
    totalCount = _ref.totalCount,
    expanded = _ref.expanded,
    onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement("a", {
    className: cx(styles.header, completedCount === totalCount && styles.allCompleted),
    onClick: onClick
  }, /*#__PURE__*/React.createElement("div", {
    className: cx(styles.icon, expanded && styles.expanded)
  }, /*#__PURE__*/React.createElement(Icon, {
    size: 18,
    material: true,
    name: "keyboard arrow right"
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.title
  }, title, " (", completedCount, " of ", totalCount, ")"));
};
export default TaskListHeader;
//# sourceMappingURL=index.js.map
